import * as React from "react";
import { Layout } from "react-admin";
import { Menu as TopBar } from "./Menu";
import { AppMenu } from "./AppMenu";
import "./layout.css";

export function MyLayout(props: any) {
  return <Layout {...props} menu={AppMenu} appBar={TopBar} />;
}
